import { useState, useMemo } from "react";
import { FaCheck } from "react-icons/fa";

export function MultiSelect({ selectedItems, items, setSelectedItems, title }) {
  const [activeCategory, setActiveCategory] = useState(null);
  const categories = [...new Set(items.map((item) => item.category))];

  const allIds = useMemo(() => items.map((item) => item._id), [items]);
  const allSelected =
    allIds.length > 0 && allIds.every((id) => selectedItems.includes(id));

  const toggleItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const toggleAll = () => {
    setSelectedItems((prev) =>
      allSelected ? [] : [...new Set([...prev, ...allIds])]
    );
  };

  const toggleCategorySelect = (category) => {
    const categoryItems = items.filter((item) => item.category === category);
    const categoryIds = categoryItems.map((item) => item._id);
    const allCategorySelected = categoryIds.every((id) =>
      selectedItems.includes(id)
    );

    setSelectedItems((prev) =>
      allCategorySelected
        ? prev.filter((id) => !categoryIds.includes(id))
        : [...new Set([...prev, ...categoryIds])]
    );
  };

  return (
    <div className="w-full border border-border rounded-md p-4 bg-dry text-sm space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-textGray">Select {title}</h3>
        <label
          className="relative flex items-center gap-2 text-xs cursor-pointer text-text select-none"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Hidden input for accessibility */}
          <input
            type="checkbox"
            checked={allSelected}
            onChange={(e) => {
              e.stopPropagation();
              toggleAll();
            }}
            className="sr-only"
          />
          <span
            className={`
      flex items-center justify-center w-4 h-4 rounded border
      border-gray-400 bg-subMain"
      ${allSelected ? "bg-subMain" : ""}
    `}
          >
            {allSelected && <FaCheck className="text-yellowdark text-[10px]" />}
          </span>
          Select All Skills
        </label>
      </div>

      {/* Horizontal category nav */}
      <div className="flex overflow-x-auto scrollbar-thin gap-2 pb-2 border-b border-border">
        {categories.map((cat) => (
          <button
            type="button"
            key={cat}
            onClick={() =>
              setActiveCategory((prev) => (prev === cat ? null : cat))
            }
            className={`px-4 py-1 rounded-full text-sm whitespace-nowrap ${
              activeCategory === cat
                ? "bg-dry text-subMain border border-subMain"
                : "text-neutral-500"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Active category content */}
      {activeCategory && (
        <div className="space-y-3">
          {/* Select All button for current category */}
          <div className="flex justify-between items-center">
            {/* <h4 className="font-semibold text-sm">{activeCategory} Services</h4> */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                toggleCategorySelect(activeCategory);
              }}
              className="text-xs underline text-subMain"
            >
              {items
                .filter((i) => i.category === activeCategory)
                .every((i) => selectedItems.includes(i._id))
                ? "Unselect All"
                : "Select All"}
            </button>
          </div>

          {/* Service Items */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {items
              .filter((item) => item.category === activeCategory)
              .map((item) => (
                <label
                  key={item._id}
                  onClick={(e) => e.stopPropagation()}
                  className="flex items-center gap-2 p-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item._id)}
                    onChange={(e) => {
                      e.stopPropagation();
                      toggleItem(item._id);
                    }}
                    className="sr-only"
                  />

                  <span
                    className={`
      flex items-center justify-center w-4 h-4 rounded border
      border-gray-400 bg-subMain"
      ${selectedItems.includes(item._id) ? "bg-subMain" : ""}
    `}
                  >
                    {" "}
                    {allSelected && (
                      <FaCheck className="text-yellowdark text-[10px]" />
                    )}
                  </span>

                  <div>
                    <p className="font-medium text-text">{item.title}</p>
                    {/* <p className="text-xs text-gray-500">
                      {item.desc} • ${item.price}
                    </p> */}
                  </div>
                </label>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
